<template>
  <div v-cloak>
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="vx-row mb-6" id="menu-top-row">
          <div class="flex w-full px-4 justify-between">
            <vs-button
              @click="createMenu()"
              class="bg_l_green"
              v-has-permission="permission165"
            >
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="ico" />
              {{ $t("CreateNewMenu") }}
            </vs-button>
            <div class="flex">
              <div class="w-full">
                <vs-button
                  @click="showFilters = !showFilters"
                  class="bg_purple float-right"
                >
                  <div class="px-3">
                    <feather-icon
                      icon="FilterIcon"
                      svgClasses="h-4 w-4"
                      class="ico"
                    />
                    {{ $t("Filter") }}
                  </div>
                </vs-button>
              </div>
            </div>
          </div>
        </div>
        <div
          class="vx-row items-end flex flex-wrap px-4 gap-y-3 gap-x-3"
          v-if="showFilters"
        >
          <div class="md:w-3/4 flex-grow">
            <vs-input
              class="inputx"
              v-model="gridSearchData.Name"
              name="Name"
              :placeholder="$t('Search')"
            />
          </div>
          <div
            class="flex-grow flex justify-end gap-4"
            style="min-width: 250px"
          >
            <vs-button type="filled" id="reset-btn" @click.prevent="resetGrid">
              <feather-icon icon="XIcon" svgClasses="h-4 w-4" class="ico" />

              {{ $t("ResetFilter") }}
            </vs-button>
            <vs-button type="filled" @click.prevent="submitFilter()">
              <feather-icon
                icon="FilterIcon"
                svgClasses="h-4 w-4"
                class="ico"
              />
              {{ $t("SubmitFilter") }}
            </vs-button>
          </div>
        </div>
        <div class="vx-row pt-4">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('Name'), sort: 'Name' },
                { title: $t('MenuPosition'), sort: 'MenuPosition' },
                { title: $t('DisplayOrder'), sort: 'DisplayOrder' },
                { title: $t('CreateOn'), sort: 'CreateOn' },
                { title: $t('Published'), sort: 'Published' },
                { title: $t('Products'), sort: 'Products' },
                { title: $t('Action') },
              ]"
            >
              <template slot-scope="{ row }">
                <td style="width: 20%">
                  {{ row.name }}
                </td>
                <td style="width: 20%">
                  {{ row.fullName }}
                </td>
                <td style="width: 7%">
                  {{ row.displayOrder }}
                </td>
                <td style="width: 15%; direction: ltr">
                  {{ row.createOn.split(" ")[0] }}<br />{{
                    row.createOn.split(" ")[1]
                  }}
                </td>
                <td style="width: 10%">
                  <vs-checkbox
                    v-model="row.published"
                    :disabled="true"
                  ></vs-checkbox>
                </td>
                <td style="width: 15%">
                  <vs-button
                    color="primary"
                    type="border"
                    icon-pack="feather"
                    icon="icon-plus"
                    class="bordered-btn"
                    @click.prevent="productPopup(row)"
                    v-has-permission="permission255"
                    >{{ $t("Products") }}</vs-button
                  >
                </td>
                <td style="width: 10%">
                  <vs-button
                    radius
                    color="success"
                    size="small"
                    type="gradient"
                    icon-pack="feather"
                    icon="icon-edit"
                    @click.prevent="editMenu(row)"
                    class="ml-4 d-inline"
                    v-has-permission="permission166"
                  ></vs-button>
                  <vs-button
                    radius
                    color="danger"
                    size="small"
                    type="gradient"
                    icon-pack="feather"
                    icon="icon-x"
                    @click.prevent="deleteMenu(row.id)"
                    class="d-inline"
                    v-has-permission="permission167"
                  ></vs-button>
                </td>
              </template>
            </data-grid>
            <product-popup
              :show="ProductPopup"
              :model="productModalModel"
              @finish="onProductModalfinish"
            ></product-popup>
          </div>
        </div>
        <modify-popup
          :show="ModifyPopup"
          :model="modalModel"
          @finish="onfinish"
          @close="closeModifyPopup"
        ></modify-popup>
      </div>
    </div>
  </div>
</template>
<style scoped>
#reset-btn {
  margin-left: 1.5rem;
  background: #3ec9d6 !important;
}
</style>
<style lang="scss">
.vs-checkbox {
  margin: 0 auto;
}
#menu-top-row button:not(.small) {
  padding: 0.3rem 0.8rem !important;
}
.bordered-btn {
  padding: 0.1rem 0.75rem !important;
  margin: 0 auto;
}
.bordered-btn i {
  padding-left: 0.2rem;
  position: relative;
  top: 2px;
  display: inline-block;
}
</style>
<script>
import { mapActions } from "vuex";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import ModifyPopup from "./ModifyPopup.vue";
import ProductPopup from "./ProductPopup.vue";

export default {
  name: "Content_management_Menus_Index",
  components: {
    ModifyPopup,
    ProductPopup,
    DataGrid,
  },
  data() {
    return {
      permission165: "CreateMenu",
      permission166: "ModifyMenu",
      permission167: "DeleteMenu",
      permission255: "AssignProductsToMenu|UnAssignProductsFromMenu",
      showFilters: false,
      ModifyPopup: false,
      ProductPopup: false,
      modalModel: {},
      productModalModel: {},
      parentName: "",
      gridDataSource: {
        type: "app",
        service: "CMS/api/MenusQuery/0",
      },
      gridSearchData: {
        keyword: "",
      },
    };
  },

  methods: {
    submitFilter() {
      this.$refs.grid.renderGrid();
    },
    resetGrid() {
      this.gridSearchData.Name = "";
      setTimeout(() => {
        this.$refs.grid.renderGrid();
      }, 0);
    },
    ...mapActions({
      removeMenus: "menu/remove",
    }),
    ////Open Modal In Create Mode
    createMenu() {
      this.modalModel = {};
      this.ModifyPopup = true;
    },
    //Open Modal In Edit Mode
    editMenu(model) {
      if (model.parentId) {
        this.parentName = model.fullName.split(">>")[0];
      } else {
        this.parentName = "";
      }
      this.modalModel = {
        id: model.id,
        name: model.name,
        parent: model.parentId,
        parentName: this.parentName,
        published: model.published,
        showOnHomePage: model.showOnHomePage,
        includeInTopMenu: model.includeInTopMenu,
        displayOrder: model.displayOrder,
        imageUri: model.imageUri,
      };
      this.ModifyPopup = true;
    },
    //Delete Method
    deleteMenu(id) {
      this.$swal({
        title: "آیا از حذف این رکورد اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.removeMenus(id).then(() => {
            this.$refs.grid.renderGrid();
          });
        }
      });
    },
    ///
    productPopup(model) {
      this.productModalModel = {
        id: model.id,
      };
      this.ProductPopup = true;
    },
    closeModifyPopup() {
      this.ModifyPopup = false;
    },
    onfinish() {
      this.closeModifyPopup();
      this.$refs.grid.renderGrid();
    },
    onProductModalfinish() {
      this.ProductPopup = false;
    },
  },
};
</script>
